
import React, { useState, useEffect } from "react"
import 'react-querybuilder/dist/query-builder.css';
import "./siteUrl.css"
import {
    Alert,
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
} from "reactstrap"


import { connect } from "react-redux"

import { setBreadcrumbItems } from "../../store/actions"
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames } from "components/Common/ApiManagement/apiServices";
import { Link, useNavigate, useParams } from "react-router-dom";
import IndividualReports from "./individualReports";
import { PAGEPATHS } from "components/Common/Constant";

const ScanNameReports = props => {
    document.title = "Add Site URL's"
    const [iframeUrl, setIframeUrl] = useState("");
    // const scanId = sessionStorage.getItem('scanId')
    const { scanId, reportName } = useParams();
    const reportTitle = reportName ? reportName.replace(/_/g, " ") : "";
const navigate=useNavigate()
    const [reportsData, setReportsData] = useState([]);
    console.log(reportsData, 'reportsDatareportsData')
    const [selectedScanName, setSelectedScanName] = useState('');
    const [indiReportsData, setIndiReportsData] = useState([]);
    const [showIndividual, setShowIndividual] = useState(false);
    const [loading, setLoading] = useState(false);
    console.log(scanId, "scanIdscanId")
    useEffect(() => {
        props.setBreadcrumbItems("Compliance Page", [])
    })

    console.log(scanId, reportTitle, "scanId, reportTitle")
    useEffect(() => {
        if (scanId && reportTitle) {
            handleScanNameList();
        }
    }, [scanId, reportTitle]);


    const handleScanNameList = async () => {
        setLoading(true)
        const response = await axiosInstance.post(ApiNames.COMPLIANCE_INDI_REPORT_LIST, { area: reportTitle, scanId: scanId });
        if (response.status) {
            setReportsData(response.data.data);
            setLoading(false)
        }
        else {
            setLoading(false)
        }

    }
    const handleIndividualReport = (data) => {
        setSelectedScanName(data.scanName)
        setShowIndividual(true)
    }
    return (
        <React.Fragment>
            {showIndividual
                ?
                <IndividualReports selectedReports={indiReportsData} setShowIndividual={setShowIndividual} selectedRepoortTitle={reportTitle} selectedScanName={selectedScanName} />


                :

                <Row className="justify-center">
                    <Col lg={12}>
                        <Card>
                            <div className="d-flex justify-content-between p-2">
                                <h1>{reportTitle}</h1>
                                <Button onClick={() => navigate(`${PAGEPATHS.ComplianceDashboard}/${scanId}`)}>Back</Button>
                            </div>
                            <CardBody>

                                {loading ?

                                    <>
                                        <h4>Loading...</h4>
                                    </>
                                    : <>
                                        {[...new Map(reportsData.map(item => [item.scanName, item])).values()].map((data, index) => (
                                            <Alert key={index} variant="dark">
                                                <Link to={`${PAGEPATHS.ComplianceDashboard}/${scanId}/${reportTitle.replace(/ /g, "_")}/${data.scanName}`}>
                                                    {data.scanName}
                                                </Link>
                                            </Alert>
                                        ))}
                                    </>
                                }




                                {/* <div>
      {iframeUrl ? (
        <iframe
          src={iframeUrl}
          frameBorder="0"
          width="100%"
          height="800"
          allowTransparency
          title="Metabase Dashboard"
        />
      ) : (
        <p>Loading dashboard...</p>
      )}
    </div> */}




                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            }
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(ScanNameReports)
